import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Whirlpool3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.WHIRLPOOL3;
}

export default Whirlpool3PoiTileEntity;
